import React from "react";

const BlankLayout = ({ children }) => (
  <div>
    {children}
  </div>
);

export default BlankLayout;
